'use strict';

/**
 * Builds the postData payload sent when an admin creates a new user on the
 * "add user" screen (Area #17): the full `user` object (firstName, lastName,
 * email, password, isAccountAdmin, permissions) plus the target `accountId`.
 * Extracted as a plain function (no angular-mocks) following the
 * edit-app-connect.js / view-user-save.js precedent so the payload shape is
 * directly testable.
 */
function buildAddUserPayload(user, account) {
    return {
        user: user,
        accountId: account.id,
    };
}

if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
    module.exports = {
        buildAddUserPayload: buildAddUserPayload,
    };
}

if (typeof angular !== 'undefined') {
    angular.module('rocket.components').value('addUserSave', {
        buildAddUserPayload: buildAddUserPayload,
    });
}
